import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';

import { DataService } from "./data.service";

@Injectable()
export class RestOperatorsService {
    server_url: string;
    private errorMessage: string;
    private tenants: string[];
    private tokenUser: string;

    constructor(
        private _dataService: DataService
    ) {
        this.server_url = this._dataService.getServer();
        this.tenants = this._dataService.getTenants();
    }

    extractData(res: Response) {
        let body = res.json();
        return body;
    }

    call(response: any, done: any) {
        response.subscribe(
            result => done(result),
            error => this.error(error, done));
    }

    handleError = (function(error: Response | any) {
        const body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        let errMsg: string = this.extractError(err);

        this.errorMessage = JSON.stringify({error: errMsg});
        return Observable.throw(errMsg);
    }.bind(this));

    getHeaderJson() {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({headers});

        return options;
    }

    getHeaderObject() {
        var headers: any = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        return headers;
    }

    getToken() {
        const token = this._dataService.getToken();
        const tokenAccess: string = 'access_token=' + token;
        return tokenAccess;
    }

    getTenant() {
        var parentRouter: string = document.location.href,
            tenants: string[] = this.tenants,
            x: number, lenX: number,
            projectIndex: number,
            tenantName: string = '',
            schema: string = 'schema/';

        for (x = 0, lenX = tenants.length; x < lenX; x++) {
            projectIndex = parentRouter.indexOf(tenants[x]);
            if(projectIndex !== -1) {
                tenantName = tenants[x];
                break;
            }
        }

        schema = schema.concat(tenantName);
        return schema;
    }

    getApiRoute(route: string, arg: string) {
        var server_url: string = this.server_url;
        var access_token = this.getToken();
        var schema: string = this.getTenant();

        if (arg) {
            route = route.concat(arg);
        }

        var apiRoute: string = server_url + '/' + route + "/" + schema + '?' + access_token;

        return apiRoute;
    }

    private error = (function(error:any, done: any) {
        error = JSON.parse(this.errorMessage);
        done(error);
    }.bind(this));

    private extractError(err: any) {
        let errMsg: string = `${err.status} - ${err.message || ''}`;
        if (err.name === 'hidrometroJaCadastradoNoDia') {
            errMsg = err;
        }

        return errMsg;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/services/rest-operators.service.ts
 **/